import { __read, __spreadArray, __values } from "tslib";
import { DataActionType } from '@tencent/memoire-core';
import { TableOperationUtils } from '../model';
import DataUpgradeTool from './data-upgrade-tool';
/**
 * Comparing the database table structure of the database,
 * migrating the changes of the data fields, including the automatic migration of the framework processing
 * and the migration items determined by the developer through the @see Model#onDataUpgrade method
 */
var CollectionDataMigrationPlanner = /** @class */ (function () {
    function CollectionDataMigrationPlanner(expectedSchema, actualSchema, modelClass) {
        this.expectedSchema = expectedSchema;
        this.actualSchema = actualSchema;
        this.modelClass = modelClass;
    }
    CollectionDataMigrationPlanner.prototype.plan = function () {
        var oldVersion = this.actualSchema.dataVersion || 0;
        var newVersion = this.expectedSchema.dataVersion || 1;
        // version not change
        if (oldVersion === newVersion) {
            return [];
        }
        var dataActions = [];
        var manualMigrationActions = this.getManualMigrationActions(oldVersion, newVersion);
        dataActions.push.apply(dataActions, __spreadArray([], __read(manualMigrationActions)));
        var autoMigrationActions = this.getAutoMigrationActions();
        dataActions.push.apply(dataActions, __spreadArray([], __read(autoMigrationActions)));
        return [
            {
                schema: {
                    actions: [],
                },
                data: {
                    actions: dataActions,
                },
            },
        ];
    };
    /**
     * get manual migration actions by model#onDataUpgrade
     * @param oldVersion
     * @param newVersion
     * @returns
     */
    CollectionDataMigrationPlanner.prototype.getManualMigrationActions = function (oldVersion, newVersion) {
        var _a, _b;
        var tool = new DataUpgradeTool(TableOperationUtils.getTableName(this.modelClass));
        (_b = (_a = this.modelClass).onDataUpgrade) === null || _b === void 0 ? void 0 : _b.call(_a, oldVersion, newVersion, tool);
        var actions = this.getRangeDataAction(oldVersion, newVersion, tool.getVersionActionsMap());
        return actions;
    };
    /**
     * get db auto migration actions
     * @param modelName
     * @param expectDataStructure
     * @param realDataStructure
     * @returns
     */
    CollectionDataMigrationPlanner.prototype.getAutoMigrationActions = function () {
        var e_1, _a;
        var _this = this;
        var actions = [];
        var dropProperties = this.actualSchema.properties.filter(function (prop) {
            if (_this.expectedSchema.properties.includes(prop)) {
                return false;
            }
            return true;
        });
        try {
            for (var dropProperties_1 = __values(dropProperties), dropProperties_1_1 = dropProperties_1.next(); !dropProperties_1_1.done; dropProperties_1_1 = dropProperties_1.next()) {
                var prop = dropProperties_1_1.value;
                actions.push({
                    type: DataActionType.DropProperty,
                    collection: TableOperationUtils.getTableName(this.modelClass),
                    path: prop,
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (dropProperties_1_1 && !dropProperties_1_1.done && (_a = dropProperties_1.return)) _a.call(dropProperties_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return actions;
    };
    /**
     * get data action between startVersion and endVersion; ps: [startVersion, endVersion];
     * @param startVersion
     * @param endVersion
     * @param actionMap
     * @returns the actions that match version rule
     */
    CollectionDataMigrationPlanner.prototype.getRangeDataAction = function (startVersion, endVersion, actionMap) {
        var actions = [];
        for (var version = startVersion; version <= endVersion; version++) {
            actions.push.apply(actions, __spreadArray([], __read((actionMap.get(version) || []))));
        }
        return actions;
    };
    return CollectionDataMigrationPlanner;
}());
export { CollectionDataMigrationPlanner };
//# sourceMappingURL=data-migration-planner.js.map